import RegisterField, { FieldProps } from "../register-field";
import { EmailField, EmailFieldProps } from "@/components/inputs";

export default function FormEmailField({
    name,
    registerOptions,
    ...props
}: FieldProps<EmailFieldProps>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <EmailField
            {...props}

            inputRef={field.ref}
            value={field.value == null ? "" : field.value}
            disabled={field.disabled}

            onChange={e => {
                field.handleChange(e.target.value);
                props.onChange && props.onChange(e);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}